import {
  CREATE_CERTIFICATE_SUCCESS,
  GET_CERTIFICATE_SUCCESS,
  PATCH_CERTIFICATE_SUCCESS,
  GET_CERTIFICATE_LIST_SUCCESS,
  GET_CERTIFICATE_PAYMENT_SETTING_SUCCESS,
  PATCH_CERTIFICATE_PAYMENT_SETTING_SUCCESS,
  PATCH_CERTIFICATE_PRICE_SUCCESS,
} from './type'

const applyPaymentPatch = (current, patchContents) => {
  if (!patchContents) return current
  const next = { ...(current ?? { isPaymentConfigured: false }) }
  patchContents.forEach(value => {
    next[value._path] = value._value
  })
  return next
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (
  state = {
    certificateList: null,
    certificate: null,
    paymentSetting: null,
  },
  action,
) {
  const { payload, type } = action
  switch (type) {
    case CREATE_CERTIFICATE_SUCCESS:
      return { ...state, certificate: payload.response }
    case GET_CERTIFICATE_SUCCESS:
      return { ...state, certificate: payload.response }
    case PATCH_CERTIFICATE_SUCCESS:
      var newCertificate = state.certificate
      payload.content._contents.map(value => {
        newCertificate[value._path] = value._value
      })

      return {
        ...state,
        certificate: newCertificate,
      }
    case GET_CERTIFICATE_LIST_SUCCESS:
      return { ...state, certificateList: payload.response }
    case GET_CERTIFICATE_PAYMENT_SETTING_SUCCESS:
      return { ...state, paymentSetting: payload.response }
    case PATCH_CERTIFICATE_PAYMENT_SETTING_SUCCESS:
      return {
        ...state,
        paymentSetting: applyPaymentPatch(
          state.paymentSetting,
          payload.content?._contents,
        ),
      }
    case PATCH_CERTIFICATE_PRICE_SUCCESS:
      return {
        ...state,
        paymentSetting: {
          ...(state.paymentSetting ?? { isPaymentConfigured: false }),
          ...payload.content,
        },
      }
    default:
      return state
  }
}
